<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h3>Force Publish</h3>

      <div class="card mt-4">
        <div class="card-body">
          <div class="form-group row mb-3">
            <label for="alsisProductCodes" class="col-sm-3 col-form-label"><b>Alsis Product Codes (comma-separated):</b></label>
            <div class="col-sm-9">
              <textarea
                id="alsisProductCodes"
                class="form-control"
                rows="5"
                [(ngModel)]="alsisProductCodesInput"
                placeholder="Enter Alsis Product Codes separated by commas, e.g., 1234, 4444, 5678"
                [disabled]="showSpinner || sendToLegacy">
              </textarea>
            </div>
          </div>

          <div class="form-group row mb-3">
            <label for="suppliers" class="col-sm-3 col-form-label"><b>Suppliers (comma-separated):</b></label>
            <div class="col-sm-9">
              <textarea
                id="suppliers"
                class="form-control"
                rows="5"
                [(ngModel)]="suppliersInput"
                placeholder="Enter Suppliers separated by commas, e.g., Supplier1, Supplier2, Supplier3"
                [disabled]="showSpinner || sendToLegacy">
              </textarea>
            </div>
          </div>

          <div class="form-group row mb-3">
            <label for="itemIds" class="col-sm-3 col-form-label"><b>Item IDs (comma-separated):</b></label>
            <div class="col-sm-9">
              <textarea
                id="itemIds"
                class="form-control"
                rows="5"
                [(ngModel)]="itemIdsInput"
                placeholder="Enter Item IDs separated by commas, e.g., 1001, 1002, 1003 (max 50)"
                [disabled]="showSpinner"
                [class.is-invalid]="isItemIdsLimitExceeded">
              </textarea>
              <small class="form-text" [class.text-danger]="isItemIdsLimitExceeded" [class.text-muted]="!isItemIdsLimitExceeded">
                {{ itemIdsCount }} / 50 Item IDs
                @if (isItemIdsLimitExceeded) {
                  <span class="fw-bold"> - Limit exceeded!</span>
                }
              </small>
            </div>
          </div>

          <div class="form-group row mb-3">
            <label for="receiver" class="col-sm-3 col-form-label"><b>Item State:</b></label>
            <div class="col-sm-9">
              <select
                id="itemState"
                class="form-select form-select-sm control-label"
                [(ngModel)]="selectedItemState"
                [disabled]="showSpinner || sendToLegacy">
                <option value="" disabled>Select an item state</option>
                @for (state of itemStateDropdownOptions; track state) {
                  <option [value]="state.value">{{ state.text }}</option>
                }
              </select>
            </div>
          </div>

          <div class="form-group row mb-3">
            <label class="col-sm-3 col-form-label"><b>Is Replaced:</b></label>
            <div class="col-sm-9">
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  class="form-check-input"
                  id="isReplacedTrue"
                  name="isReplaced"
                  [value]="true"
                  [(ngModel)]="isReplaced"
                  [disabled]="showSpinner || sendToLegacy">
                  <label class="form-check-label" for="isReplacedTrue">
                    True
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="isReplacedFalse"
                    name="isReplaced"
                    [value]="false"
                    [(ngModel)]="isReplaced"
                    [disabled]="showSpinner || sendToLegacy">
                    <label class="form-check-label" for="isReplacedFalse">
                      False
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="isReplacedNull"
                      name="isReplaced"
                      [value]="null"
                      [(ngModel)]="isReplaced"
                      [disabled]="showSpinner || sendToLegacy">
                      <label class="form-check-label" for="isReplacedNull">
                        Undefined
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group row mb-3">
                  <label class="col-sm-3 col-form-label"><b>Is Configured:</b></label>
                  <div class="col-sm-9">
                    <div class="form-check form-check-inline">
                      <input
                        type="radio"
                        class="form-check-input"
                        id="isConfiguredTrue"
                        name="isConfigured"
                        [value]="true"
                        [(ngModel)]="isConfigured"
                        [disabled]="showSpinner || sendToLegacy">
                        <label class="form-check-label" for="isConfiguredTrue">
                          True
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          type="radio"
                          class="form-check-input"
                          id="isConfiguredFalse"
                          name="isConfigured"
                          [value]="false"
                          [(ngModel)]="isConfigured"
                          [disabled]="showSpinner || sendToLegacy">
                          <label class="form-check-label" for="isConfiguredFalse">
                            False
                          </label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            type="radio"
                            class="form-check-input"
                            id="isConfiguredNull"
                            name="isConfigured"
                            [value]="null"
                            [(ngModel)]="isConfigured"
                            [disabled]="showSpinner || sendToLegacy">
                            <label class="form-check-label" for="isConfiguredNull">
                              Undefined
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="form-group row mb-3">
                        <label for="lastModificationDateTimeFrom" class="col-sm-3 col-form-label"><b>Last Modification Date From:</b></label>
                        <div class="col-sm-9">
                          <kendo-datetimepicker
                            id="lastModificationDateTimeFrom"
                            [(value)]="lastModificationDateTimeFrom"
                            [disabled]="showSpinner || sendToLegacy"
                            format="yyyy-MM-dd HH:mm">
                          </kendo-datetimepicker>
                        </div>
                      </div>

                      <div class="form-group row mb-3">
                        <label for="lastModificationDateTimeTo" class="col-sm-3 col-form-label"><b>Last Modification Date To:</b></label>
                        <div class="col-sm-9">
                          <kendo-datetimepicker
                            id="lastModificationDateTimeTo"
                            [(value)]="lastModificationDateTimeTo"
                            [disabled]="showSpinner || sendToLegacy"
                            format="yyyy-MM-dd HH:mm">
                          </kendo-datetimepicker>
                        </div>
                      </div>

                      <div class="form-group row mb-3">
                        <label for="receiver" class="col-sm-3 col-form-label"><b>Receiver:</b></label>
                        <div class="col-sm-9">
                          <select
                            id="receiver"
                            class="form-select form-select-sm control-label"
                            [(ngModel)]="selectedReceiver"
                            [disabled]="showSpinner || sendToLegacy">
                            <option value="" disabled>Select a receiver</option>
                            @for (receiver of receivers; track receiver) {
                              <option [value]="receiver">{{ receiver }}</option>
                            }
                          </select>
                        </div>
                      </div>

                      @if (!isProduction) {
                        <div class="form-group row mb-3">
                          <label class="col-sm-3 col-form-label"><b>Send To Legacy:</b></label>
                          <div class="col-sm-9">
                            <div class="form-check">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="sendToLegacy"
                                [ngModel]="sendToLegacy"
                                (ngModelChange)="onSendToLegacyChange($event)"
                                [disabled]="showSpinner">
                              <label class="form-check-label" for="sendToLegacy">Enabled</label>
                            </div>
                          </div>
                        </div>
                      }

                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm me-2"
                        (click)="onSubmit()"
                        [disabled]="showSpinner || isItemIdsLimitExceeded">
                        @if (showSpinner) {
                          <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                        }
                        {{ showSpinner ? 'Submitting...' : 'Submit' }}
                      </button>

                      @if (error) {
                        <div class="alert alert-danger mt-3" role="alert">
                          {{ errorMessage }}
                        </div>
                      }

                      @if (success) {
                        <div class="alert alert-success mt-3" role="alert">
                          {{ successMessage }}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
